import React from 'react';
import Avatar from '@mui/material/Avatar';
import Button from '@mui/material/Button';
import CssBaseline from '@mui/material/CssBaseline';
import TextField from '@mui/material/TextField';
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';
import { Link as RouterLink } from 'react-router-dom'; 
import Paper from '@mui/material/Paper';
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import LockOutlinedIcon from '@mui/icons-material/LockOutlined';
import Typography from '@mui/material/Typography';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import backgroundImage from '../assets/logo512.jpg';
import { useNavigate } from 'react-router-dom';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { loginAlumni } from '../components/apifa';
import { useDispatch } from "react-redux";
import { SetUser } from "../redux/userSlice";


const defaultTheme = createTheme();

export default function LoginAlumni() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [email, setEmail] = React.useState('');
  const [password, setPassword] = React.useState('');
  const [isloading, setIsLoading] = React.useState(false);

  const validatePassword = (password) => {
    const regex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,15}$/;
    return regex.test(password);
  }

  const isFormValid = () => {
    return (
      email.trim() !== '' &&
      password.trim() !== '' &&
      password.length >= 2
    );
  }

  const handleSubmit = async (event) => {
    event.preventDefault();
    const data = new FormData(event.currentTarget);
  
    const loginData = {
      email: data.get("email"),
      password: data.get("password"),
    };
  
    if (!loginData.email || !loginData.password) {
      toast.error("Email and password are required!");
      return;
    }
  
    setIsLoading(true);
    try {
      const result = await loginAlumni(loginData);
      toast.success("Login successful!");
      
      setTimeout(() => {
        navigate("/alumni/dashboard");
      }, 1000);
    } catch (error) {
      toast.error("Invalid credentials!");
    } finally {
      setIsLoading(false);
    }
  };
  

  return (
    <Box>
   
    <ThemeProvider theme={defaultTheme}>.
      
      <Grid container component="main" sx={{ height: '80vh'  }}>
        
        <CssBaseline />
        <ToastContainer />
        <Grid
          item
          xs={false}
          sm={4}
          md={7}
          sx={{
            backgroundImage: `url(${backgroundImage})`,
            backgroundSize: 'cover',
            backgroundPosition: 'center',
          }}
        />
        <Grid item xs={12} sm={8} md={5} component={Paper} elevation={6} square>
          <Box
            sx={{
              my: 8,
              mx: 4,
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
            }}
          >
            <Avatar sx={{ m: 1, bgcolor: 'secondary.main' }}>
              <LockOutlinedIcon />
            </Avatar>
            <Typography component="h1" variant="h5">
              Sign in Alumni
            </Typography>
            <Box component="form" noValidate onSubmit={handleSubmit} sx={{ mt: 1 }}>
              <TextField
                margin="normal"
                required
                fullWidth
                id="email"
                label="Email Address"
                name="email"
                autoComplete="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                autoFocus
              />
              <TextField
                margin="normal"
                required
                fullWidth
                name="password"
                label="Password"
                type="password"
                id="password"
                autoComplete="current-password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
              />
              <FormControlLabel
                control={<Checkbox value="remember" color="primary" />}
                label="Remember me"
              />
              <Button
                type="submit"
                fullWidth
                variant="contained"
                sx={{ mt: 3, mb: 2 }}
                disabled={!isFormValid() || isloading}
              >
                {isloading ? 'Logging in...' : 'Sign In'}
              </Button>
              <Grid container>
                <Grid item>
                  <RouterLink to="/alumni/signup" variant="body2">
                    {"Don't have an account? Sign Up"}
                  </RouterLink>
                </Grid>
              </Grid>

              {/* Admin Icon with External Link */}
              
            </Box>
          </Box>
        </Grid>
      </Grid>
    </ThemeProvider>
    </Box>
  );
}
